<template>
  <div class="progress-bar-container">
    <div
      class="progress-bar"
      :style="{ width: progress + '%' }"
      :class="{ 'complete': progress === 100 }"
    ></div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'

const progress = ref(0)
const timer = ref(null)

const start = () => {
  progress.value = 0
  timer.value = setInterval(() => {
    if (progress.value < 90) {
      progress.value += Math.random() * 10
    }
  }, 100)
}

const finish = () => {
  clearInterval(timer.value)
  progress.value = 100
  setTimeout(() => {
    progress.value = 0
  }, 500)
}

const fail = () => {
  clearInterval(timer.value)
  progress.value = 0
}

onMounted(() => {
  // Listen for custom events from router
  window.addEventListener('progress-start', start)
  window.addEventListener('progress-finish', finish)
  window.addEventListener('progress-fail', fail)
})

onBeforeUnmount(() => {
  // Clean up event listeners
  window.removeEventListener('progress-start', start)
  window.removeEventListener('progress-finish', finish)
  window.removeEventListener('progress-fail', fail)
  if (timer.value) {
    clearInterval(timer.value)
  }
})
</script>

<style scoped>
.progress-bar-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  z-index: 9999;
  pointer-events: none;
}

.progress-bar {
  height: 100%;
  background: #29e8c6;
  transition: width 0.1s ease-out;
  box-shadow: 0 0 10px rgba(41, 232, 198, 0.5);
}

.progress-bar.complete {
  transition: width 0.3s ease-in;
}
</style>
